document.documentElement.classList.remove('no-js');

const qs = (selector, scope = document) => scope.querySelector(selector);
const qsa = (selector, scope = document) => [...scope.querySelectorAll(selector)];

const menuToggle = qs('[data-menu-toggle]');
const mobileNav = qs('[data-mobile-nav]');
const menuOverlay = qs('[data-menu-overlay]');
const menuClose = qs('[data-menu-close]');
const setMobileMenu = (open) => {
  if (!menuToggle || !mobileNav) return;
  mobileNav.classList.toggle('open', open);
  menuOverlay?.classList.toggle('active', open);
  document.body.classList.toggle('menu-open', open);
  menuToggle.setAttribute('aria-expanded', String(open));
  mobileNav.setAttribute('aria-hidden', String(!open));
};
if (menuToggle && mobileNav) {
  menuToggle.addEventListener('click', () => setMobileMenu(!mobileNav.classList.contains('open')));
  menuClose?.addEventListener('click', () => setMobileMenu(false));
  menuOverlay?.addEventListener('click', () => setMobileMenu(false));
  qsa('.mobile-nav a', mobileNav).forEach((link) => link.addEventListener('click', () => setMobileMenu(false)));
}

const searchToggle = qs('[data-search-toggle]');
const searchPanel = qs('[data-search-panel]');
if (searchToggle && searchPanel) {
  searchToggle.addEventListener('click', () => {
    searchPanel.hidden = !searchPanel.hidden;
    if (!searchPanel.hidden) qs('input', searchPanel)?.focus();
  });
}

qsa('[data-footer-toggle]').forEach((toggle) => {
  toggle.addEventListener('click', () => {
    const content = toggle.nextElementSibling;
    const open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(open));
    toggle.classList.toggle('active', open);
    content?.classList.toggle('open', open);
  });
});

const filterToggle = qs('[data-filter-toggle]');
const filterClose = qs('[data-filter-close]');
const facets = qs('[data-facets]');
filterToggle?.addEventListener('click', () => facets?.classList.add('open'));
filterClose?.addEventListener('click', () => facets?.classList.remove('open'));

qsa('[data-product-thumbs] [data-media-id]').forEach((button) => {
  button.addEventListener('click', () => {
    qsa('[data-media-id]').forEach((item) => item.classList.remove('active'));
    qsa('[data-media-panel]').forEach((item) => item.classList.add('hidden'));
    button.classList.add('active');
    qs(`[data-media-panel="${button.dataset.mediaId}"]`)?.classList.remove('hidden');
  });
});

qsa('[data-tab]').forEach((button) => {
  button.addEventListener('click', () => {
    qsa('[data-tab]').forEach((item) => item.classList.remove('active'));
    qsa('[data-tab-panel]').forEach((item) => item.classList.add('hidden'));
    button.classList.add('active');
    qs(`[data-tab-panel="${button.dataset.tab}"]`)?.classList.remove('hidden');
  });
});

qsa('[data-showcase-tab]').forEach((button) => {
  button.addEventListener('click', () => {
    const root = button.closest('[data-artisan-showcase]');
    if (!root) return;
    qsa('[data-showcase-tab]', root).forEach((item) => {
      const active = item === button;
      item.classList.toggle('active', active);
      item.setAttribute('aria-selected', String(active));
    });
    qsa('[data-showcase-panel]', root).forEach((panel) => {
      panel.hidden = panel.dataset.showcasePanel !== button.dataset.showcaseTab;
      panel.classList.toggle('hidden', panel.hidden);
    });
  });
});

const productRoot = qs('[data-product-root]');
if (productRoot) {
  const variantData = qs('[data-product-variants]', productRoot);
  const variants = variantData ? JSON.parse(variantData.textContent) : [];
  const optionGroups = qsa('[data-option-index]', productRoot);
  const moneyFormat = window.Shopify?.currency?.active || '';

  const updateVariant = () => {
    const selected = optionGroups.map((group) => qs('.option-pill.selected', group)?.dataset.optionValue);
    const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
    const idInput = qs('[data-variant-id]', productRoot);
    const addButton = qs('[data-add-to-cart]', productRoot);
    if (!variant) {
      addButton.disabled = true;
      addButton.textContent = 'Unavailable';
      return;
    }
    idInput.value = variant.id;
    qs('[data-product-price]', productRoot).textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: moneyFormat || 'USD' }).format(variant.price / 100);
    const sku = qs('[data-product-sku]', productRoot);
    if (sku) sku.textContent = variant.sku;
    addButton.disabled = !variant.available;
    addButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
    history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
  };

  optionGroups.forEach((group) => qsa('.option-pill', group).forEach((button) => button.addEventListener('click', () => {
    qsa('.option-pill', group).forEach((item) => item.classList.remove('selected'));
    button.classList.add('selected');
    updateVariant();
  })));

  const quantity = qs('input[name="quantity"]', productRoot);
  qs('[data-qty-minus]', productRoot)?.addEventListener('click', () => quantity.value = Math.max(1, Number(quantity.value) - 1));
  qs('[data-qty-plus]', productRoot)?.addEventListener('click', () => quantity.value = Number(quantity.value) + 1);
}
